import { apiClient } from '@utils';

export const useChartsAuth = () => {
  const result = apiClient.chart.auth.useQuery(['charts-auth'], {});
  return { ...result, data: result.data?.body };
};
